var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container-lg mx-auto",class:_vm.slim ? 'px-0 px-md-4' : 'px-3'},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }